<template>
  <div class="text-right">
    <table class="table table-sm color">
      <caption class="caption table-caption">{{type}} Information</caption>
      <tbody>
        <tr>
          <th class="text-left font-weight-normal">Original Balance</th>
          <td class="text-right">{{originalBalance}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Current Balance</th>
          <td class="text-right">{{currentBalance}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">Deal Factor</th>
          <td class="text-right">{{dealFactor}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">WAC</th>
          <td class="text-right">{{WAC}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">WAM</th>
          <td class="text-right">{{WAM}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">WALA</th>
          <td class="text-right">{{WALA}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal" v-if="type == 'Pool'">Historical Losses</th>
          <th class="text-left font-weight-normal" v-else>Projected Losses</th>
          <td :class="[{blue: type != 'Pool'}, 'text-right']">{{projectedLosses}}</td>
        </tr>
      </tbody>
    </table>
    <b-btn variant="primary" v-if="$store.getters.isCollateralUser && type != 'Pool'"
      @click="$emit('downloadCollateral', dealName, month)">Download {{dealName}} collateral for {{month}}</b-btn>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "Collateral"
    },
    originalBalance: { type: String},
    currentBalance: { type: String},
    dealFactor: { type: String},
    WAC: { type: String},
    WAM: { type: String},
    WALA: { type: String},
    projectedLosses: { type: String},
    dealName: { type: String},
    month: { type: String}
  }
}
</script>
